import { useEffect, useMemo, useRef, useState } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import Lottie from "lottie-react";
import BotVcc from "assets/Icons/vccAgentBg.webp";
import CenterDataJson from "assets/animations/bot/AI data progress.json";
import success from "assets/animations/bot/Success.json";
import { FontFamily } from "assets";
import { useLocation, useNavigate } from "react-router-dom";

const VccAgents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const agentType = location.state?.agent;

  const handleClick = () => {
    agentType
      ? agentType === "prepaid"
        ? navigate("/prepaid-auction-charges-list")
        : navigate("/upload-declaration")
      : navigate("/upload-declaration");
  };
  const STEPS = useMemo(
    () =>
      agentType === "prepaid"
        ? [
            { name: "Agent DocuSift", duration: 5500 },
            { name: "Agent ChargeMaster", duration: 6000 },
          ]
        : [
            { name: "Agent Astra", duration: 5500 },
            { name: "Agent Solara", duration: 6000 },
            { name: "Agent Ceres", duration: 6000 },
          ],
    []
  );

  const [stepIndex, setStepIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [finished, setFinished] = useState(false);
  const rafRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (finished) return;
    const duration = STEPS[stepIndex].duration;
    setProgress(0);
    startTimeRef.current = null;

    const tick = (t) => {
      if (startTimeRef.current == null) startTimeRef.current = t;
      const elapsed = t - startTimeRef.current;
      const pct = Math.min(100, (elapsed / duration) * 100);
      setProgress(pct);

      if (pct < 100) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        if (stepIndex < STEPS.length - 1) setStepIndex((i) => i + 1);
        else setFinished(true);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    };
  }, [STEPS, stepIndex, finished]);

  if (finished) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          backgroundImage: `url(${BotVcc})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 4, md: 6 },

          gap: "40px",
          pb: 3,
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            // top: { xs: 16, md: 24 },
            // width: "323px",
            // height: "69px",
            // right: { xs: 16, md: 32 },
            // border: "2px solid #fff",
            // borderRadius: "100px",
            // px: "50px",
            // py: "12px",
            fontWeight: 600,
            textAlign: "center",
            alignItems: "center",
            // fontSize: "30px",
            bgcolor: "rgba(0,0,0,0.15)",
            backdropFilter: "blur(2px)",
          }}
        />
        <Box
          sx={{
            position: "relative",
            textAlign: "center",
            alignItems: "center",
            zIndex: 1,
          }}
        >
          <Box sx={{ width: 600, height: 400, mx: "auto" }}>
            <Lottie
              animationData={success}
              loop={false}
              style={{ width: "100%", height: "100%" }}
            />
          </Box>

          <Typography
            sx={{
              fontFamily: FontFamily.openSans,
              fontWeight: 400,
              fontStyle: "Regular",
              fontSize: "36px",
              mb: 1,
              textShadow: "0 1px 8px rgba(0,0,0,0.6)",
            }}
          >
            Job Completed Successfully!
          </Typography>
          <Typography
            sx={{
              fontSize: "30px",
              fontFamily: FontFamily.openSans,
              fontWeight: 400,
              fontStyle: "Regular",
              opacity: 0.95,
              maxWidth: 900,
              mx: "auto",
              lineHeight: 1.6,
            }}
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            You can now review detailed insights in the{" "}
            <span style={{ textDecoration: "underline" }}>
              Analytics section
            </span>
            .
          </Typography>

          {/* <Typography sx={{
                        fontSize: "30px", fontFamily: FontFamily.openSans,
                        fontWeight: 400,
                        fontStyle: "Regular", opacity: 0.95, maxWidth: 900, mx: "auto", lineHeight: 1.6
                    }}>
                        You can now review detailed insights in the Analytics section.
                    </Typography> */}
        </Box>
      </Box>
    );
  }

  const currentAgent = STEPS[stepIndex].name;

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundImage: `url(${BotVcc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 4, md: 6 },

        gap: "40px",
        pb: 3,
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: { xs: 16, md: 24 },
          //   width: "323px",
          maxWidth: "100%",
          height: "69px",
          right: { xs: 16, md: 32 },
          border: "2px solid #fff",
          borderRadius: "100px",
          px: "50px",
          py: "12px",
          textAlign: "center",
          fontSize: "36px",
          bgcolor: "rgba(0,0,0,0.15)",
          backdropFilter: "blur(2px)",
          fontFamily: FontFamily.openSans,
          fontWeight: 400,
          fontStyle: "Regular",
        }}
      >
        {currentAgent}
      </Box>
      {/* Stage area – stack children with a fixed 100px gap */}
      <Box
        sx={{
          width: "min(1200px, 92vw)",
          height: { xs: 460, md: 560 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "100px", // ⟵ exact space between the two Boxes
        }}
      >
        {/* Lottie – remove absolute positioning */}
        <Box sx={{ width: 749, height: 562, maxWidth: "100%" }}>
          <Lottie
            animationData={CenterDataJson}
            loop
            style={{ width: "100%", height: "100%" }}
          />
        </Box>

        {/* Progress – remove absolute positioning */}
        <Box sx={{ width: { xs: "88vw", sm: 420, md: 590 } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.25,
              px: 0.5,
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                fontFamily: FontFamily.openSans,
                fontWeight: 400,
                fontStyle: "Regular",
                opacity: 0.9,
                whiteSpace: "nowrap",
              }}
            >
              {stepIndex === 0 && agentType === "prepaid"
                ? "Processing invoices storage and late fee..."
                : stepIndex === 0 && agentType !== "prepaid"
                ? "Container detected C001.."
                : ""}
              {stepIndex === 1 && agentType === "prepaid"
                ? "Perfrom AI-Base prepaid auction charges..."
                : stepIndex === 0 && agentType !== "prepaid"
                ? "Declaration & Vcc Processed.."
                : ""}
              {stepIndex === 0 &&
                agentType !== "prepaid" &&
                "AI-Based analysis in progress.."}
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                opacity: 0.9,
                fontVariantNumeric: "tabular-nums",
                whiteSpace: "nowrap",
              }}
            >
              {Math.round(progress)}%
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: "16px",
              borderRadius: 999,
              backgroundColor: "rgba(255,255,255,0.25)",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#22C55E",
                borderRadius: 999,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default VccAgents;
